<template>
  <nav class="head">
    <div class="logo">
      <img style="width:100%; height:auto;" src="../../images/u2.png" alt="Logo">
    </div>

    <!-- 移动端菜单按钮 -->
    <button class="hamburger" @click="toggleMobileMenu">
      <span class="menu-icon" :class="{ 'open': isMobileMenuOpen }"></span>
    </button>

    <div class="navigation" :class="{ 'mobile-active': isMobileMenuOpen }">
      <div class="navbar">
        <ul>
          <li
            v-for="(item, index) in navigationItems"
            :key="item.label"
            @mouseenter="handleMouseEnter(index)"
            @mouseleave="handleMouseLeave(index)"
            class="nav-item"
            :class="{ 'has-children': item.children }"
          >
            <a 
              href="#" 
              class="headA" 
              @click.prevent="handleItemClick(index)"
            >
              {{ item.label }}
              <span v-if="isMobile && item.children" class="dropdown-arrow">
                {{ item.showDropdown ? '▼' : '▶' }}
              </span>
            </a>
            <div
              v-if="item.children"
              class="dropdown"
              :class="{ 'dropdown-visible': item.showDropdown }"
              @mouseenter="cancelHide(index)"
              @mouseleave="hideDropdown(index)"
            >
              <div
                v-for="(child, i) in item.children"
                :key="i"
                class="dropdown-item"
                @click="goTo(child.href)"
              >
                {{ child.label }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { reactive, ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const isMobileMenuOpen = ref(false)
const isMobile = ref(false)

// 导航数据
const navigationItems = reactive([
  {
    label: '首页',
    href: '/',
    showDropdown: false,
    timer: null
  },
  {
    label: '产品中心',
    href: '/Products',
    showDropdown: false,
    timer: null,
    children: [
      { label: '云仓服务', href: '/CloudWarehouse' },
      { label: '软件系统', href: '/Softwaresys' },
      { label: '硬件集成', href: '/hardware' }
    ]
  },
  {
    label: '客户案例',
    href: '/Case',
    showDropdown: false,
    timer: null
  },
  {
    label: '最新资讯',
    href: '/information',
    showDropdown: false,
    timer: null
  },
  {
    label: '关于我们',
    href: '/CompanyProfile',
    showDropdown: false,
    timer: null,
    children: [
      { label: '加入我们', href: '/JoinUs' }
    ]
  }
])

// 检测设备类型
function checkDevice() {
  isMobile.value = window.innerWidth <= 768
  if (!isMobile.value) {
    isMobileMenuOpen.value = false
    navigationItems.forEach(item => {
      item.showDropdown = false
    })
  }
}

// 处理点击事件
function handleItemClick(index) {
  const item = navigationItems[index]
  if (isMobile.value) {
    if (item.children) {
      item.showDropdown = !item.showDropdown
    } else {
      goTo(item.href)
    }
  } else {
    goTo(item.href)
  }
}

// 鼠标进入显示下拉
function handleMouseEnter(index) {
  if (isMobile.value) return
  if (navigationItems[index].children) {
    showDropdown(index)
  }
}

// 鼠标离开隐藏下拉
function handleMouseLeave(index) {
  if (isMobile.value) return
  if (navigationItems[index].children) {
    scheduleHideDropdown(index)
  }
}

// 显示下拉菜单
function showDropdown(index) {
  hideAllDropdowns()
  navigationItems[index].showDropdown = true
}

// 延迟隐藏下拉
function scheduleHideDropdown(index) {
  const item = navigationItems[index]
  item.timer = setTimeout(() => {
    item.showDropdown = false
  }, 200)
}

// 取消隐藏
function cancelHide(index) {
  const item = navigationItems[index]
  if (item.timer) {
    clearTimeout(item.timer)
    item.timer = null
  }
}

// 隐藏下拉
function hideDropdown(index) {
  navigationItems[index].showDropdown = false
}

// 路由跳转
function goTo(href) {
  if (router.currentRoute.value.path !== href) {
    router.push(href)
    closeMobileMenu()
  }
}

// 隐藏所有下拉
function hideAllDropdowns() {
  navigationItems.forEach(item => {
    item.showDropdown = false
  })
}

// 切换移动端菜单
function toggleMobileMenu() {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

// 关闭移动端菜单
function closeMobileMenu() {
  isMobileMenuOpen.value = false
  navigationItems.forEach(item => {
    item.showDropdown = false
  })
}

onMounted(() => {
  checkDevice()
  window.addEventListener('resize', checkDevice)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkDevice)
})
</script>

<style scoped>
/* PC端样式 - 保留原始布局 */
.head {
  position: fixed;
  background-color: rgba(233, 233, 233, 0.259);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  font-family: sans-serif;
  padding: 0 20px;
}

.logo {
  color: white;
  font-weight: bold;
  height: 100%;
  width: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  margin-left: 20px;
}

.navbar ul {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 500px;
  height: 60px;
}

.navbar ul li {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  overflow: visible;
}

.navbar ul li:hover {
  background-color: rgba(105, 105, 105, 0.3);
}

.headA {
  text-decoration: none;
  color: #000;
  display: block;
  z-index: 1;
  position: relative;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -20%);
  text-align: center;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 120px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 999;
  padding: 10px 0;
  margin-top: 10px;
}

.dropdown::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -8px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

.dropdown-visible {
  opacity: 1;
  visibility: visible;
}

.dropdown-item {
  margin: 10px 20px;
  cursor: pointer;
  color: #333;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: rgba(52, 132, 252, 0.4);
}

.navigation {
  margin-right: 80px;
}

.hamburger {
  display: none;
}

.dropdown-arrow {
  display: none;
}

/* 移动端样式 - 采用优化后的侧滑菜单 */
@media (max-width: 768px) {
  .hamburger {
    display: block;
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    z-index: 1001;
    position: relative;
  }

  .menu-icon {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #333;
    position: relative;
    transition: all 0.3s ease;
  }

  .menu-icon::before,
  .menu-icon::after {
    content: '';
    position: absolute;
    width: 25px;
    height: 3px;
    background-color: #333;
    transition: all 0.3s ease;
  }

  .menu-icon::before {
    top: -8px;
  }

  .menu-icon::after {
    bottom: -8px;
  }

  .menu-icon.open {
    background-color: transparent;
  }

  .menu-icon.open::before {
    transform: translateY(8px) rotate(45deg);
  }

  .menu-icon.open::after {
    transform: translateY(-8px) rotate(-45deg);
  }

  .navigation {
    position: fixed;
    top: 0;
    right: -300px;
    width: 300px;
    height: 100vh;
    background-color: rgba(233, 233, 233, 0.95);
    margin-right: 0;
    transition: right 0.3s ease;
    z-index: 1000;
    padding-top: 100px;
    overflow-y: auto;
  }

  .navigation.mobile-active {
    right: 0;
  }

  .navbar ul {
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 0 30px;
  }

  .navbar ul li {
    width: 100%;
    height: auto;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  .navbar ul li:last-child {
    border-bottom: none;
  }

  .headA {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    transform: none;
    top: 0;
    left: 0;
    text-align: left;
  }

  .dropdown-arrow {
    display: inline-block;
    font-size: 16px;
    color: #000;
    width: 20px;
    text-align: center;
  }

  .dropdown {
    position: static;
    background-color: transparent;
    box-shadow: none;
    opacity: 1;
    visibility: visible;
    transform: none;
    margin-top: 0;
    padding-left: 20px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .dropdown-visible {
    max-height: 300px;
  }

  .dropdown::before {
    display: none;
  }

  .dropdown-item {
    margin: 5px 0;
    padding: 8px 0;
  }
}
</style>